<template>
  <div
    class="modal fade"
    ref="configModal"
    id="configModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="titleConfigLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="titleConfigLabel">
            {{ $t('modal.title_config_chart', [config.id]) }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="cancelEditModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- ACCORDION -->
          <div class="accordion" id="accordionForm">
            <div class="card">
              <div class="card-header compact" ref="accordion-header-1" id="headingData">
                <h5 class="mb-0">
                  <button
                    :class="!config.id ? 'btn btn-link' : 'btn btn-link collapsed'"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseData"
                    :aria-expanded="!config.id ? 'true' : 'false'"
                    aria-controls="collapseData"
                  >
                    1. {{ $t('modal.tab_data_header') }}
                  </button>
                  <span class="text-dark" style="font-size: 0.6em" v-if="config.id"
                    ><i>{{ $t('modal.new_request_infos') }}</i></span
                  >
                </h5>
              </div>

              <div
                id="collapseData"
                :class="!config.id ? 'collapse show' : 'collapse'"
                aria-labelledby="headingData"
                data-parent="#accordionForm"
              >
                <div class="card-body text-dark">
                  <!-- Chart data values -->
                  <div class="form-group row" v-if="hasDataValue">
                    <label for="inputChartDataValue" class="col-sm-4 col-form-label"
                      >{{ $t('modal.type_of_data') }}
                    </label>
                    <div class="col-sm-8">
                      <select
                        id="inputChartDataValue"
                        v-model="config.data_value"
                        :class="dataValueForm"
                        @change="onDataTypeChange"
                      >
                        <optgroup
                          v-for="group in $props.hierarchy.chart_data_group"
                          :key="group"
                          :label="$t('chart.data_group.' + group)"
                        >
                          <option
                            v-for="value in $props.hierarchy.chart_data_values[group]"
                            :value="value"
                            :key="value"
                            selected
                          >
                            {{ $t('chart.data_value.' + value) }}
                          </option>
                        </optgroup>
                      </select>
                    </div>
                  </div>

                  <!-- Chart data types -->
                  <div id="chart-data-types" class="form-group row" v-if="hasDataType">
                    <label for="inputChartDataType" class="col-sm-4 col-form-label">{{
                      $t('modal.in')
                    }}</label>
                    <div class="col-sm-8">
                      <select
                        id="inputChartDataType"
                        v-model="config.data_type"
                        :class="dataTypeForm"
                        @change="onDataTypeChange"
                      >
                        <option
                          v-for="value in $props.hierarchy.chart_data_types[config.data_value]"
                          :value="value"
                          :key="value"
                        >
                          {{ $t('chart.data_type.' + value) }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Chart distribution data types -->
                  <div
                    id="chart-distribution-data-types"
                    class="form-group row pb-3"
                    v-if="isDistributionChart"
                  >
                    <label for="inputChartDistributionType" class="col-sm-4 col-form-label">{{
                      $t('modal.distribution_type')
                    }}</label>
                    <div class="col-sm-8">
                      <select
                        id="inputChartDistributionType"
                        v-model="config.distribution_type"
                        class="form-control form-control-sm"
                        @change="onDataDistributionTypeChange"
                      >
                        <option
                          v-for="value in $props.hierarchy.chart_distribution_types[
                            config.data_value
                          ]"
                          :value="value"
                          :key="value"
                        >
                          {{ $t('filter.' + value) }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Display by -->
                  <div id="chart-display-by" class="form-group row pb-3" v-if="isSortableChart">
                    <label for="inputSortBy" class="col-sm-4 col-form-label">{{
                      $t('display_by')
                    }}</label>
                    <div class="col-sm-8">
                      <select
                        id="inputSortBy"
                        v-model="config.sort_by"
                        class="form-control form-control-sm"
                        @change="onDataTypeChange"
                      >
                        <option key="all" value="all">{{ $t('filter.all') }}</option>
                        <option
                          v-for="value in $props.hierarchy.chart_distribution_types[
                            config.data_value
                          ]"
                          :value="value"
                          :key="value"
                        >
                          {{ $t('filter.' + value) }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Chart type -->
                  <!-- Smartphone -->
                  <div
                    id="chart-type-smartphone"
                    class="form-group row"
                    v-if="displayAvailableChartsForSmartphoneScreen"
                  >
                    <label for="inputChartType" class="col-sm-4 col-form-label">{{
                      $t('modal.chart_type')
                    }}</label>
                    <div class="col-sm-8">
                      <select id="inputChartType" v-model="config.type" :class="chartTypeForm">
                        <option
                          v-for="value in $props.hierarchy.charts[config.data_type]"
                          :value="value"
                          :key="value"
                        >
                          {{ $t('chart.' + value) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- Desktop -->
                  <div
                    id="chart-type"
                    class="form-group row justify-content-md-center"
                    v-if="!displayAvailableChartsForSmartphoneScreen"
                  >
                    <div class="btn-group" data-toggle="buttons">
                      <label
                        :class="
                          value == config.type
                            ? 'btn btn-sm btn-light active'
                            : 'btn btn-sm btn-light'
                        "
                        v-for="value in allowedChartTypes"
                        :key="value"
                        @click="toggleClick(value)"
                        v-tooltip="{
                          content: '<img src=/img/chart_' + value + '.png>',
                          html: true,
                          placement: 'bottom-center',
                        }"
                      >
                        <i :class="chartIcon(value)"></i><br />
                        <input
                          class="toggle"
                          type="radio"
                          name="options"
                          checked="checked"
                          :value="value"
                          v-model="config.type"
                        />
                        {{ $t('chart.' + value) }}
                      </label>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div id="chart-filters" v-if="configFilters">
                    <span v-if="config.filters && config.filters.length > 0"
                      ><strong>{{ $t('modal.filters') }}</strong></span
                    >
                    <div
                      class="form-group row align-items-center"
                      v-for="(filter, index) in config.filters"
                      :key="index"
                    >
                      <label :for="'input' + filter.type" class="col-sm-4 col-form-label">{{
                        $t('filter.' + filter.type)
                      }}</label>
                      <div class="col-sm-7">
                        <select
                          class="custom-select form-control form-control-sm"
                          v-model="filter.values"
                          :id="'input' + filter.type"
                          multiple
                        >
                          <option
                            v-for="value in configFilters.filter_values[filter.type]"
                            :value="value"
                            :key="value"
                          >
                            {{ getFilterValueLabel(filter.type, value) }}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-1 text-center">
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="deleteFilter(index)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>

                    <!--<h5 class="text-dark rounded">{{ $t('filter.by') }}</h5>-->

                    <!-- Filters -->
                    <div class="form-group row">
                      <div
                        class="form-inline col-sm-12"
                        v-for="(filter, index) in newFilters"
                        :key="index"
                      >
                        <select
                          class="form-control form-control-sm m-2 mr-sm-2 col"
                          v-model="inputFilters[index]"
                        >
                          <option v-for="value in availableFilters" :value="value" :key="value">
                            {{ $t('filter.' + value) }}
                          </option>
                        </select>
                        <select
                          class="form-control form-control-sm m-2 mr-sm-2 col"
                          v-model="inputFiltersValues[index]"
                          multiple
                        >
                          <option
                            v-for="value in allowedFilterValues[inputFilters[index]]"
                            :value="value"
                            :key="value"
                          >
                            {{ getFilterValueLabel(inputFilters[index], value) }}
                          </option>
                        </select>
                        <button
                          type="button"
                          class="btn btn-sm btn-danger m-2 mr-sm-2"
                          @click="deleteRow(index)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                        <button
                          v-if="inputFiltersValues[index].length > 0"
                          type="button"
                          class="btn btn-sm btn-success m-2 mr-sm-2"
                          @click="validateRow(index)"
                        >
                          <i class="fas fa-check"></i>
                        </button>
                        <button
                          v-if="inputFiltersValues[index].length == 0"
                          type="button"
                          class="btn btn-sm btn-success m-2 mr-sm-2 disabled"
                          v-tooltip="{ content: $t('filter.add_invalid'), placement: 'top-center' }"
                        >
                          <i class="fas fa-check"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row justify-content-md-center">
                    <button
                      v-if="newFilters.length == 0"
                      type="button"
                      class="btn btn-sm btn-light m-2 col-sm-4"
                      @click="addRowFilter()"
                    >
                      <i class="fas fa-plus"></i> {{ $t('add_filters') }}
                    </button>
                    <button
                      v-if="newFilters.length > 0"
                      type="button"
                      class="btn btn-sm btn-light m-2 col-sm-4 disabled"
                      v-tooltip="{ content: $t('filter.select_invalid'), placement: 'top-center' }"
                    >
                      <i class="fas fa-plus"></i> {{ $t('add_filters') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Display options -->
            <div class="card">
              <div
                class="card-header compact"
                id="headingDisplayOptions"
                v-if="config.display_options"
              >
                <h2 class="mb-0">
                  <button
                    :class="
                      config.id && config.id != '' ? 'btn btn-link' : 'btn btn-link collapsed'
                    "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseDisplayOptions"
                    :aria-expanded="config.id && config.id != '' ? 'true' : 'false'"
                    aria-controls="collapseDisplayOptions"
                    @click="onDisplayOptionsForPreviewChange"
                  >
                    2. {{ $t('display_options_title') }}
                  </button>
                </h2>
              </div>
              <div
                id="collapseDisplayOptions"
                :class="config.id && config.id != '' ? 'collapse show' : 'collapse'"
                aria-labelledby="headingDisplayOptions"
                data-parent="#accordionForm"
              >
                <div class="card-body text-dark" v-if="config && config.display_options">
                  <!-- CHART TITLES -->
                  <div
                    class="form-group row justify-content-md-center"
                    v-if="config && config.titles"
                  >
                    <div class="col-sm-3">
                      <select
                        id="inputTitleLanguage"
                        class="form-control form-control-sm"
                        v-model="localeTitle"
                      >
                        <option v-for="(value, index) in locales" :value="value" :key="index">
                          {{ $t('modal.title') }} - {{ value.toUpperCase() }}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-9">
                      <input
                        type="title"
                        :maxlength="maxCharacters"
                        class="form-control form-control-sm"
                        id="inputTitle"
                        :placeholder="$t('modal.title')"
                        v-model="config.titles[localeTitle]"
                        @input="onConfigTitleInput()"
                      />
                      <div
                        v-if="
                          generatedChartTitles[localeTitle] !== '' &&
                            generatedChartTitles[localeTitle] !== config.titles[localeTitle]
                        "
                      >
                        <!-- SUGGESTED TITLE -->
                        <span style="font-size: small">
                          {{ $t('chart.title_suggested') }} :
                          <i>{{ generatedChartTitles[localeTitle] }} ? </i></span
                        ><button type="button" class="btn btn-sm ml-2" @click="updateConfigTitles">
                          <i class="fas fa-check"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Chart display options -->
                  <div
                    class="form-group row align-items-center"
                    v-if="
                      (config.type === 'indicator' && config.sort_by && config.sort_by !== 'all') ||
                        config.type === 'bar' ||
                        config.type === 'pie'
                    "
                  >
                    <label class="col-sm-auto col-form-label">{{ $t('display_by') }}</label>
                    <div class="col-auto">
                      <select
                        class="form-control form-control-sm"
                        v-model="config.display_options.display_by"
                        @change="onDisplayOptionsForPreviewChange"
                      >
                        <option value="none">{{ $t('sort.none') }}</option>
                        <option value="value_asc">{{ $t('sort.by_value_asc') }}</option>
                        <option value="value_desc">{{ $t('sort.by_value_desc') }}</option>
                        <option value="site_id_asc" v-if="config.sort_by === 'site_id'">
                          {{ $t('sort.by_site_id_asc') }}
                        </option>
                        <option value="site_id_desc" v-if="config.sort_by === 'site_id'">
                          {{ $t('sort.by_site_id_desc') }}
                        </option>
                        <option value="alpha_asc">{{ $t('sort.by_alpha_asc') }}</option>
                        <option value="alpha_desc">{{ $t('sort.by_alpha_desc') }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row align-items-center" v-if="config.type !== 'indicator'">
                    <label class="col-sm-auto col-form-label">{{ $t('modal.display_mode') }}</label>
                    <div class="col-auto">
                      <select
                        class="form-control form-control-sm"
                        v-model="config.display_options.display_mode"
                        @change="onDisplayOptionsForPreviewChange"
                      >
                        <option value="expanded">{{ $t('display_options.expanded') }}</option>
                        <option value="compact">{{ $t('display_options.compact') }}</option>
                      </select>
                    </div>
                    <label class="col-sm-auto col-form-label">{{ $t('legend') }}</label>
                    <div class="col-sm-auto">
                      <select
                        class="form-control form-control-sm"
                        v-model="config.display_options.legend"
                        @change="onDisplayOptionsForPreviewChange"
                      >
                        <option value="expanded">{{ $t('display_options.expanded') }}</option>
                        <option value="compact">{{ $t('display_options.compact') }}</option>
                        <option value="none">{{ $t('display_options.none') }}</option>
                      </select>
                    </div>
                  </div>
                  <div
                    class="form-group row align-items-center"
                    v-if="
                      config.type != 'indicator' && config.type != 'pie' && config.type != 'matrix'
                    "
                  >
                    <div class="col-sm-auto">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="displayGridCheck"
                          v-model="config.display_options.display_grid"
                          @change="onDisplayOptionsForPreviewChange"
                        />
                        <label class="form-check-label" for="displayGridCheck">
                          {{ $t('modal.display_grid') }}
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-auto" v-if="config.type == 'time'">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="displayGridCheck"
                          v-model="config.display_options.display_weekend"
                          @change="onDisplayOptionsForPreviewChange"
                        />
                        <label class="form-check-label" for="displayGridCheck">
                          {{ $t('modal.display_weekend') }}
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-auto" v-if="config.type == 'time'">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="zoomedCheck"
                          v-model="config.display_options.zoomed"
                          @change="onDisplayOptionsForPreviewChange"
                        />
                        <label class="form-check-label" for="zoomedCheck">
                          {{ $t('modal.zoom') }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group row align-items-center"
                    v-if="config.type == 'time' && config.sort_by != 'all'"
                  >
                    <div class="col-sm-auto">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="config.display_options.stacked"
                          id="stackedCheck"
                          @change="onStackedChecked"
                        />
                        <label class="form-check-label" for="stackedCheck">
                          {{ $t('modal.stacked') }}
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-auto" v-if="config.display_options.stacked">
                      <select
                        class="form-control form-control-sm"
                        v-model="config.display_options.stacked_mode"
                        @change="onDisplayOptionsForPreviewChange"
                      >
                        <option value="volume">Volume</option>
                        <option value="percentage">%</option>
                      </select>
                    </div>
                  </div>
                  <!-- Chart displayed in preview -->
                  <div class="container" v-if="previewConfig">
                    <label class="row">Preview</label>
                    <div class="chart row p-2">
                      <div class="col-sm-12">
                        <time-chart
                          v-if="previewConfig.type == 'time'"
                          :config="previewConfig"
                          :ref="'chart-preview-' + previewConfig.id"
                          :chartId="'timechart-preview-' + previewConfig.id"
                          :period="period"
                          :area="area"
                          :mode="!isRequestedDataChanged ? 'preview' : 'new_config'"
                          :previewDataset="!isRequestedDataChanged ? previewDataset : {}"
                        ></time-chart>
                        <indicator-chart
                          v-if="previewConfig.type == 'indicator'"
                          :config="previewConfig"
                          :ref="'chart-preview-' + config.id"
                          :chartId="'indicatorchart-preview-' + config.id"
                          :period="period"
                          :area="area"
                          :mode="!isRequestedDataChanged ? 'preview' : 'new_config'"
                          :previewDataset="!isRequestedDataChanged ? previewDataset : {}"
                        ></indicator-chart>
                        <day-chart
                          v-if="previewConfig.type == 'day'"
                          :config="previewConfig"
                          :ref="'chart-preview-' + config.id"
                          :chartId="'daytimechart-preview-' + config.id"
                          :period="period"
                          :area="area"
                          :mode="!isRequestedDataChanged ? 'preview' : 'new_config'"
                          :previewDataset="!isRequestedDataChanged ? previewDataset : {}"
                        ></day-chart>
                        <pie-chart
                          v-if="previewConfig.type == 'pie'"
                          :config="previewConfig"
                          :ref="'chart-preview-' + config.id"
                          :chartId="'piechart-preview-' + config.id"
                          :period="period"
                          :area="area"
                          :mode="!isRequestedDataChanged ? 'preview' : 'new_config'"
                          :previewDataset="!isRequestedDataChanged ? previewDataset : {}"
                        ></pie-chart>
                        <bar-chart
                          v-if="previewConfig.type == 'bar'"
                          :config="previewConfig"
                          :ref="'chart-preview-' + config.id"
                          :chartId="'barchart-preview-' + config.id"
                          :period="period"
                          :area="area"
                          :mode="!isRequestedDataChanged ? 'preview' : 'new_config'"
                          :previewDataset="!isRequestedDataChanged ? previewDataset : {}"
                        ></bar-chart>
                        <matrix-chart
                          v-if="previewConfig.type == 'matrix'"
                          :config="previewConfig"
                          :ref="'chart-preview-' + config.id"
                          :chartId="'matrixchart-preview-' + config.id"
                          :period="period"
                          :area="area"
                          :mode="!isRequestedDataChanged ? 'preview' : 'new_config'"
                          :previewDataset="!isRequestedDataChanged ? previewDataset : {}"
                        ></matrix-chart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div v-if="isSmartphone">
            <button
              v-if="this.$props.type === 'update' > 0"
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="confirmDeleteConfig"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
            <button
              type="button"
              v-if="newFilters.length == 0"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="saveConfig()"
            >
              {{ $t('save') }}
            </button>
            <button
              type="button"
              v-if="newFilters.length > 0"
              class="btn btn-primary disabled"
              v-tooltip="{ content: $t('chart.save_invalid'), placement: 'top-center' }"
            >
              {{ $t('save') }}
            </button>
          </div>
          <div v-if="!isSmartphone">
            <button
              type="button "
              class="btn btn-secondary"
              @click="downloadChartConfig()"
              v-tooltip="{ content: $t('download.chart_config'), placement: 'top-center' }"
            >
              <i class="fas fa-download"></i>
            </button>
            <file-select v-model="file" @loadConfig="onLoadConfig"></file-select>
            <button
              type="button"
              class="btn btn-secondary"
              v-tooltip="{ content: $t('chart.paste_info'), placement: 'top-center' }"
              @click="pasteConfig()"
            >
              <i class="fas fa-paste"></i>
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              v-tooltip="{ content: $t('chart.copy_info'), placement: 'top-center' }"
              @click="copyConfig()"
            >
              <i class="fas fa-copy"></i>
            </button>
            <button
              v-if="this.$props.type === 'update'"
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="confirmDeleteConfig"
            >
              {{ $t('chart.delete') }}
            </button>

            <button
              type="button"
              class="btn btn-primary disabled"
              v-if="!checkIfBatteryChartOK() && config.type == 'battery'"
              v-tooltip="{ content: $t('chart.save_battery_invalid'), placement: 'top-center' }"
            >
              {{ $t('save') }}
            </button>

            <button
              type="button"
              v-if="newFilters.length == 0 && checkIfBatteryChartOK()"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="saveConfig()"
            >
              {{ $t('save') }}
            </button>
            <button
              type="button"
              v-if="newFilters.length > 0 && config.type != 'battery'"
              class="btn btn-primary disabled"
              v-tooltip="{ content: $t('chart.save_invalid'), placement: 'top-center' }"
            >
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utilsMixin, sitesMixin } from '../utils/mixins'

export default {
  name: 'EditChartModal',
  mixins: [utilsMixin, sitesMixin],
  data() {
    return {
      newFilters: [],
      inputs: [],
      inputFilters: [],
      inputFiltersValues: [],
      selectedFilters: [],
      viewportWidth: window.innerWidth,
      isSmartphone: window.innerWidth <= 575,
      file: null,
      localeTitle: this.$locale,
      maxCharacters: 100,
      configFilters: undefined,
      stacked: null,
      show: false,
      initialConfig: null,
      previewConfig: null,
      generatedChartTitles: {
        fr: '',
        en: '',
        de: '',
      },
      chartConfigTitles: {
        fr: {
          title: '',
          modified: false,
        },
        en: {
          title: '',
          modified: false,
        },
        de: {
          title: '',
          modified: false,
        },
      },
    }
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    previewDataset: Object,
    type: {
      type: String,
      required: true,
    },
    hierarchy: {
      type: Object,
      required: true,
    },
    period: {
      type: Array,
      required: true,
    },
    area: String,
  },
  mounted() {
    this.configFilters = JSON.parse(JSON.stringify(this.configFilterHierarchy))
  },
  components: {
    'file-select': () => import('./utils/FileSelect'),
    'time-chart': () => import('./charts/TimeChart'),
    'indicator-chart': () => import('./charts/IndicatorChart'),
    'pie-chart': () => import('./charts/PieChart'),
    'bar-chart': () => import('./charts/BarChart'),
    'day-chart': () => import('./charts/DayTimeChart'),
    'matrix-chart': () => import('./charts/MatrixChart'),
  },
  computed: {
    allowedChartTypes: function() {
      let allowedTypes = this.configChartHierarchy

      if (this.config.data_value == 'affluence' && this.config.data_type == 'count') {
        allowedTypes = ['time', 'matrix']
      } else if (
        (this.config.data_value == 'affluence' ||
          this.config.data_value == 'visit' ||
          this.config.data_value == 'email' ||
          this.config.data_value == 'comment' ||
          this.config.data_value == 'histomaton_file' ||
          this.config.data_value == 'upload' ||
          this.config.data_value == 'duplicate' ||
          this.config.data_value == 'email_delivered' ||
          this.config.data_value == 'email_open' ||
          this.config.data_value == 'email_click' ||
          this.config.data_value == 'email_delivered' ||
          this.config.data_value == 'email_open_session' ||
          this.config.data_value == 'email_click_session' ||
          this.config.data_value == 'survey_answer_session') &&
        this.config.data_type == 'average_count'
      ) {
        allowedTypes = ['indicator']
      } else if (
        (this.config.data_value == 'visit' ||
          this.config.data_value == 'email' ||
          this.config.data_value == 'comment' ||
          this.config.data_value == 'upload') &&
        this.config.data_type == 'average_count'
      ) {
        allowedTypes = ['indicator']
      } else if (
        this.config.data_value != 'visit' &&
        this.config.data_value != 'email' &&
        this.config.data_value != 'comment' &&
        this.config.data_value != 'is_crash' &&
        this.config.data_value != 'uploaded_time' &&
        this.config.data_value != 'upload' &&
        this.config.data_type == 'count'
      ) {
        allowedTypes = ['time', 'indicator']
      } else {
        allowedTypes = allowedTypes.charts[this.config.data_type]
      }

      if (this.config.sort_by && this.config.sort_by !== 'all' && allowedTypes.indexOf('pie') < 0) {
        allowedTypes.push('pie')
      }

      if (this.config.sort_by && this.config.sort_by !== 'all' && allowedTypes.indexOf('bar') < 0) {
        allowedTypes.push('bar')
      }

      if (!allowedTypes) {
        allowedTypes = []
      }

      return allowedTypes
    },
    allowedFilterValues: function() {
      let filterValues = JSON.parse(JSON.stringify(this.configFilters.filter_values))

      if (this.config.filters.length > 0 || this.inputFilters.length > 0) {
        const configFiltersTemp = { filter_values: {} }

        const siteIDFilter = this.config.filters.find(f => {
          return f.type === 'site_id' || f.type === 'site_location'
        })

        if (siteIDFilter) {
          siteIDFilter.values.forEach(siteID => {
            for (const key in this.configFilters.custom[siteID]) {
              if (!configFiltersTemp.filter_values[key]) {
                configFiltersTemp.filter_values[key] = this.configFilters.custom[siteID][key]
              } else {
                configFiltersTemp.filter_values[key] = configFiltersTemp.filter_values[key].concat(
                  this.configFilters.custom[siteID][key].filter(f => {
                    return configFiltersTemp.filter_values[key].indexOf(f) < 0
                  }),
                )
              }
            }
          })

          for (const key in filterValues) {
            if (configFiltersTemp.filter_values[key]) {
              filterValues[key] = configFiltersTemp.filter_values[key]
            }
          }
        }
      }

      return filterValues
    },
    availableFilters: function() {
      const availableFilters = this.configFilters.filters.filter(filter => {
        const selectedFilter = this.config.filters.find(configFilter => {
          return configFilter.type === filter
        })
        if (
          selectedFilter ||
          filter === 'site_id' ||
          (this.config.data_value === 'stuck_log' && filter === 'site_location') ||
          (this.config.data_value !== 'stuck_log' && filter === 'site')
        ) {
          return false
        } else {
          return true
        }
      })

      return availableFilters
    },
    allowedSortByValues: function() {
      let sortByValues = this.$props.hierarchy.chart_distribution_types[this.config.data_value]
      if (sortByValues) {
        sortByValues = sortByValues.filter(value => {
          return value != this.config.data_value
        })

        return sortByValues
      } else {
        return []
      }
    },
    dataValueForm: function() {
      return {
        'form-control': true,
        'form-control-sm': true,
        'is-invalid': this.config.data_value == '',
      }
    },
    dataTypeForm: function() {
      return {
        'form-control': true,
        'form-control-sm': true,
        'is-invalid': this.config.data_type == '',
      }
    },
    chartTypeForm: function() {
      return {
        'form-control': true,
        'form-control-sm': true,
        'is-invalid': this.config.type == '',
      }
    },
    chartTitleForm: function() {
      return {
        'form-control': true,
        'form-control-sm': true,
        'is-invalid': this.config.title == '',
      }
    },
    hasDataType: function() {
      return this.config.data_type && this.$props.hierarchy.chart_data_types
    },
    hasDataValue: function() {
      return this.config.data_value && this.$props.hierarchy.chart_data_values
    },
    isDistributionChart: function() {
      const isDistributionChart =
        this.config.data_type &&
        this.config.data_value &&
        this.$props.hierarchy.charts &&
        this.config.data_type == 'distribution'

      return isDistributionChart
    },
    isSortableChart: function() {
      let isSortableChart =
        this.config.data_type &&
        this.config.data_value &&
        this.$props.hierarchy.charts &&
        this.config.data_type != 'distribution' &&
        this.config.data_value != 'battery_lifetime' &&
        this.config.type != 'day' &&
        this.config.type != 'rotation' &&
        this.config.type != 'battery' &&
        this.config.type != 'matrix'
      /*if (!isSortableChart) {
        this.config.sort_by = 'all'
      }*/
      return isSortableChart
    },
    displayAvailableChartsForSmartphoneScreen: function() {
      return (
        this.config.data_type &&
        this.config.data_value &&
        this.$props.hierarchy.charts &&
        this.isSmartphone
      )
    },
    isRequestedDataChanged: function() {
      if (!this.config.id) {
        return true
      } else if (
        this.initialConfig.type != this.config.type ||
        this.initialConfig.data_type != this.config.data_type ||
        this.initialConfig.data_value != this.config.data_value ||
        this.initialConfig.sort_by != this.config.sort_by ||
        this.initialConfig.distribution_type != this.config.distribution_type ||
        JSON.stringify(this.initialConfig.filters) != JSON.stringify(this.config.filters)
      ) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    config: {
      handler: function(config) {
        setTimeout(() => {
          this.initialConfig = JSON.parse(JSON.stringify(config))
          this.previewConfig = JSON.parse(JSON.stringify(config))

          if (!this.previewConfig.sort_by || this.previewConfig.sort_by === '') {
            this.previewConfig.sort_by = 'all'
          }

          this.show = false
          this.$nextTick(() => {
            if (this.config.titles) {
              this.initConfigChartTitles('fr')
              this.initConfigChartTitles('en')
              this.initConfigChartTitles('de')

              this.localeTitle = this.$locale
            }
            this.show = true
          })
        }, 300)
      },
      immediate: true,
    },
    period: {
      handler: function() {},
      immediate: true,
    },
    previewDataset: {
      handler: function() {},
      immediate: false,
    },
    isSortableChart: {
      deep: true,
      handler: val => {
        if (!val) {
          this.config.sort_by = 'all'
        }
      },
    },
    allowedSortByValues: {
      deep: true,
      handler: () => {
        if (this && this.$props) {
          let sortByValues = this.$props.hierarchy.chart_distribution_types[this.config.data_value]
          sortByValues = sortByValues.filter(value => {
            return value != this.config.data_value
          })
          if (sortByValues.indexOf(this.config.sort_by) == -1) {
            this.config.sort_by = sortByValues[0]
          }
        }
      },
    },
  },
  methods: {
    initConfigChartTitles: function(locale) {
      this.chartConfigTitles[locale] = {
        title: '',
        modified: false,
      }
      if (!this.config.titles[locale] || this.config.titles[locale] === '') {
        this.config.titles[locale] = this.generateChartTitle(locale, this.config)
        this.chartConfigTitles[locale].modified = false
      } else {
        this.chartConfigTitles[locale].modified = true
      }
      this.chartConfigTitles[locale].title = this.config.titles[locale]
    },
    addRowFilter: function() {
      this.newFilters.push({})
      this.inputFilters.push(this.availableFilters[0])
      this.inputFiltersValues.push([])
    },
    deleteFilter(index) {
      this.config.filters.splice(index, 1)
    },
    deleteRow(index) {
      this.newFilters.splice(index, 1)
      this.inputFilters.splice(index, 1)
      this.inputFiltersValues.splice(index, 1)
    },
    validateRow(index) {
      this.config.filters.push({
        type: this.inputFilters[index],
        values: this.inputFiltersValues[index],
      })
      this.deleteRow(index)
    },
    confirmDeleteConfig: function() {
      this.$emit('confirmDelete', this.config)
    },
    cancelEditModal: function() {
      this.$emit('cancelEdit')
    },
    saveConfig: function() {
      if (this.isFormValid()) {
        this.previewConfig = null

        let chartConfig = JSON.parse(JSON.stringify(this.config))

        if (!this.isDistributionChart) {
          chartConfig.distribution_type = ''
        }
        this.$emit(this.$props.type, chartConfig)
      } else {
        console.error('Error occurend when tried to save the config.')
        // TODO
      }
    },
    isFormValid: function() {
      if (this.config && this.config.data_type) {
        if (this.config.data_type != 'distribution') {
          if (this.config.type == 'time' && this.config.sort_by == 'all') {
            if (this.config.display_options) {
              this.config.display_options['stacked'] = false
            } else {
              this.config['display_options'] = { stacked: false }
            }
          }
          return (
            this.config.data_type != '' && this.config.data_value != '' && this.config.type != ''
          )
        } else {
          return (
            this.config.data_type != '' &&
            this.config.data_value != '' &&
            this.config.type != '' &&
            this.config.distribution_type != ''
          )
        }
      } else {
        if (this.config.type == 'time' && this.config.sort_by == 'all') {
          if (this.config.display_options) {
            this.config.display_options['stacked'] = false
          } else {
            this.config['display_options'] = { stacked: false }
          }
        }
        return true
      }
    },
    toggleClick: function(toggleType) {
      this.config.type = toggleType
      this.updateDefaultChartTitles()
    },
    chartIcon: function(toggleType) {
      switch (toggleType) {
        case 'time':
          return 'fas fa-chart-area'
        case 'indicator':
          return 'fas fa-sort-numeric-up'
        case 'pie':
          return 'fas fa-chart-pie'
        case 'bar':
          return 'fas fa-chart-bar'
        case 'day':
          return 'fas fa-chart-line'
        case 'rotation':
          return 'fas fa-th-large'
        case 'matrix':
          return 'fas fa-th'
        default:
          return 'fas fa-chart-line'
      }
    },
    onDataTypeChange: function() {
      if (
        this.$props.hierarchy.chart_data_types[this.config.data_value].indexOf(
          this.config.data_type,
        ) == -1
      ) {
        this.config.data_type = this.$props.hierarchy.chart_data_types[this.config.data_value][0]
      } else {
        if (this.config.data_type === 'distribution') {
          this.config.distribution_type = 'language'
        } else {
          //If the selected sort by value is not available for the specific combination of data the user asked
          if (
            this.$props.hierarchy.chart_distribution_types[this.config.data_value].indexOf(
              this.config.sort_by,
            ) == -1
          ) {
            this.config.sort_by = 'all'
          }
        }
      }

      this.allowedChartTypes.includes(this.config.type)
        ? this.config.type
        : (this.config.type = this.allowedChartTypes[0])

      this.updateDefaultChartTitles()

      //If user did not set a chart's title... we generate it
      for (let key in this.chartConfigTitles) {
        if (!this.chartConfigTitles[key].modified) {
          this.config.titles[key] = this.generatedChartTitles[key]
        }
      }
    },
    updateDefaultChartTitles() {
      this.generatedChartTitles['fr'] = this.generateChartTitle('fr', this.config)
      this.generatedChartTitles['en'] = this.generateChartTitle('en', this.config)
      this.generatedChartTitles['de'] = this.generateChartTitle('de', this.config)
    },
    updateConfigTitles() {
      this.config.titles[this.localeTitle] = this.generatedChartTitles[this.localeTitle]
    },
    onDataDistributionTypeChange: function() {
      if (
        this.$props.hierarchy.chart_data_types[this.config.data_value].indexOf(
          this.config.data_type,
        ) == -1
      ) {
        this.config.data_type = this.$props.hierarchy.chart_data_types[this.config.data_value][0]
      }
      if (this.allowedChartTypes.includes(this.config.type)) {
        this.config.type = this.allowedChartTypes[0]
      }
      this.updateDefaultChartTitles()
    },
    copyConfig: function() {
      this.$session.start()
      this.$session.set('copiedChartConfig', this.config)
    },
    pasteConfig: function() {
      if (this.$session.has('copiedChartConfig')) {
        this.loadConfig(this.$session.get('copiedChartConfig'))
      }
    },
    downloadChartConfig: function() {
      var configData = JSON.stringify(this.config, undefined, 4)
      const blob = new Blob([configData], { type: 'text/json' })
      const link = document.createElement('a')
      link.setAttribute('download', `export_chart_config_${this.config.id}.json`)
      link.href = window.URL.createObjectURL(blob)
      link.dataset.downloadurl = ['text/json', link.download, link.href].join(':')
      link.click()
    },
    onLoadConfig: function(file) {
      this.loadConfig(JSON.parse(file))
    },
    loadConfig: function(loadedConfig) {
      this.config.class = loadedConfig.class
      this.config.data_type = loadedConfig.data_type
      this.config.data_value = loadedConfig.data_value
      this.config.filters = loadedConfig.filters
      this.config.sort_by = loadedConfig.sort_by
      this.config.distribution_type = loadedConfig.distribution_type
      ;(this.config.type = loadedConfig.type), (this.config.title = loadedConfig.title)
    },
    onConfigTitleInput: function() {
      this.chartConfigTitles[this.localeTitle].modified = true
    },
    checkIfBatteryChartOK: function() {
      if (this.config.type == 'battery') {
        //Check if only one site_id is set in filters
        var founds = this.config.filters.filter(f => {
          return f.type == 'site_id'
        })
        if (founds && founds.length == 1 && founds[0].values.length == 1) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    onStackedChecked: function() {
      if (this.config.display_options['stacked']) {
        this.config.display_options['stacked_mode'] = 'volume'
      } else {
        delete this.config.display_options['stacked_mode']
      }

      this.onDisplayOptionsForPreviewChange()
    },
    onDisplayOptionsForPreviewChange: function() {
      setTimeout(() => {
        this.previewConfig = JSON.parse(JSON.stringify(this.config))
        if (!this.isDistributionChart) {
          this.previewConfig.distribution_type = ''
        }
        this.updateDefaultChartTitles()
      }, 300)
    },
    getFilterValueLabel(filterType, value) {
      switch (filterType) {
        case 'site_location':
          return this.getLocalizedSiteName(value)
        case 'site_id':
        case 'language':
        case 'product':
        case 'warning_type':
          return this.$t(filterType + '.' + value)
        case 'site':
        case 'status':
          return this.$i18n.messages[this.$locale][filterType][value]
        default:
          return value
      }
    },
  },
}
</script>

<style>
.toggle {
  visibility: hidden;
}
.compact {
  padding: 0 !important;
}
</style>
